/* eslint-disable import/prefer-default-export */
import employee from 'url:../../../assets/employee.jpg';
import champion from 'url:../../../assets/champion.jpg';
import innovation from 'url:../../../assets/innovation.jpg';

export interface Program {
  id: string;
  image: string;
  title: string;
  description: string;
}

export const programs = [
  {
    id: 'big-boxer-of-the-month',
    image: employee,
    title: 'Big Boxer of the Month',
    description: 'Big Boxer of the month nominations.',
  },
  {
    id: 'charitable-champion',
    image: champion,
    title: 'Charitable Champion',
    description: 'The Charitable Champion program is designed to feature those Big Boxers who are extra charitable in their work!',
  },
  {
    id: 'most-innovative',
    image: innovation,
    title: 'Most Innovative',
    description: 'The most innovative program highlights those Big Boxers with the most innovative idea or victory on the frontline!',
  },
];
